export default __webpack_public_path__ + "static/media/7d94db9d72e528b625d1156d0b7733db.png";